import { ApiBucket, ApiBucketPayload } from "@incendium/api";
import { trafficBucketService } from "Apis";

const bucketToPayload = (bucket: ApiBucket): ApiBucketPayload => {
  return {
    name: bucket.name,
    groups: bucket.groups,
    attributionTags: (bucket.tags || []).map((t) => t.id as number),
  };
};

export const saveTrafficBucket = async (projectId: number, bucket: ApiBucket) => {
  const fn = bucket.id ? trafficBucketService.bucketServiceUpdateBucket({
    projectId,
    bucketId: bucket.id as number,
    payload: bucketToPayload(bucket),
  }) : trafficBucketService.bucketServiceCreateBucket({
    projectId,
    payload: bucketToPayload(bucket),
  });
  const res = await fn;
  return res;
};  